import React from 'react';
import cx from 'classnames';
import { css } from 'emotion';
import { DisplayableItem } from './display/media-displayer';
import MediaGalleryItemView from './media-gallery-item-view';
import { cssInJS } from '../../utils/styles';

type Props = {
  className?: string,
  activeItem: DisplayableItem,
  mediaValueItems: Array<DisplayableItem>,
  onMediaChange: (item: DisplayableItem) => void,
};

export default class MediaGalleryView extends React.Component<Props> {
  render() {
    // @ts-ignore
    const { styles } = MediaGalleryView;

    return (
      <div className={cx(this.props.className, styles.container)}>
        <div className={css(styles.thumbnailContainer)}>
          {this.renderItems()}
        </div>
      </div>
    );
  }

  renderItems() {
    return this.props.mediaValueItems.map((item) => (
      <MediaGalleryItemView
        key={item.item.mediaID}
        item={item}
        active={this.props.activeItem === item}
        onClick={this.props.onMediaChange}
      />
    ));
  }
}

const styles = cssInJS({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    textAlign: 'center',
  },

  thumbnailContainer: {
    maxWidth: '100%',
    height: '100%',
    display: 'inline-block',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    whiteSpace: 'nowrap',
    paddingLeft: 20,
    paddingRight: 20,
  },
}) as any;
// @ts-ignore
MediaGalleryView.styles = styles;
